<template>
    <section id="content" v-if="get_FlagServicesShowBookingnoSearchResults">
        <div class="container">
            <div class="block" id="contentElementBookingno">
                <!-- >>> BreadCrumbs - Row -->
                <div class="row">
                    <!-- >>> VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                    <sdr-breadcrumbs active_item="first" :module="modulo"></sdr-breadcrumbs>
                    <!-- <<< VueCmp - 'sdr-breadcrumbs', 'Breadcrumbs' -->
                </div>
                <!-- <<< BreadCrumbs - Row -->


                <!-- >>> 'Bookinno Search Results' - Row -->
                <div class="row">
                    <div class="container shortcode travel-ideas">
                        <h1 class="idea-title" style="margin-bottom:30px;"><span class="index"><i class="soap-icon-arrow-right circle"></i></span>{{ headline_step1[getCurrentLocale] }}</h1>
                    </div>


                    <!-- >>> Left Side: 'SearchResults' -->
                    <div class="col-sm-8 col-md-9">

                        <!-- >>> Booking Details -->
                        <div id="flight-features" class="tab-container">
                            <!-- >>> TabHeader:  -->
                            <ul class="tabs">
                                <li class="active">
                                    <a href="#flight-details" data-toggle="tab">{{ tab_flightdetails[getCurrentLocale] }}</a>
                                </li>
                                <!-- <li><a href="#inflight-features" data-toggle="tab">{{ tab_inflightfeatures[getCurrentLocale] }}</a></li> -->
                            </ul>
                            <!-- <<< TabHeader:  -->

                            <!-- >>> Tab Content: -->
                            <div class="tab-content">
                                <!-- >>> Tab: 'flight-details' -->
                                <div class="tab-pane fade in active" id="flight-details">
                                    <!-- >>> VueCmp - 'sdr-flight-details', 'Flight Details', Outward Flight' -->
                                    <sdr-bookingno-flight-details flightdirection="outward" v-if="get_ServicesBookingnoHasOutwardFlight"></sdr-bookingno-flight-details>
                                    <!-- <<< VueCmp - 'sdr-flight-details', 'Flight Details', Outward Flight' -->

                                    <!-- >>> 'Return Flight' Part -->
                                    <div v-if="get_ServicesBookingnoHasReturnFlight">
                                        <br />
                                        <hr />
                                        <br />
                                        <!-- >>> VueCmp - 'sdr-flight-details', 'Flight Details', Return Flight-->
                                        <sdr-bookingno-flight-details flightdirection="return"></sdr-bookingno-flight-details>
                                        <!-- <<< VueCmp - 'sdr-flight-details', 'Flight Details', Return Flight-->
                                    </div>
                                    <!-- <<< 'Return Flight' Part -->
                                </div>
                                <!-- <<< Tab: 'flight-details' -->
                            </div>
                            <!-- <<< Tab Content: -->
                        </div>
                        <!-- <<< Booking Details -->



                        <br />
                        <br />
                        <!-- >>> ProceedButton(s) -->
                        <button type="submit" class="btn-large icon-check uppercase full-width" v-bind:class="{ sundairsrvcs: modulo === 'services', 'icon-check3': modulo === 'services' }" @click.prevent="call_nextCalls()">{{ proceed[getCurrentLocale] }}</button>
                        <!-- <a class="button btn-large uppercase full-width silver">{{ proceed[getCurrentLocale] }} </a> -->
                        <!-- <<< ProceedButton(s) -->
                    </div>
                    <!-- <<< Left Side: 'SearchResults' -->


                    <!-- >>> Right Side: Sidebar -->
                    <div class="sidebar col-sms-6 col-sm-4 col-md-3 topDistance" style="">
                        <h2>&nbsp;</h2>
                        <h4 class="search-results-title"><i class="soap-icon-search"></i><b>{{ get_ServicesBookingnoPassengersCountAll }}</b> {{ resultsshown[getCurrentLocale] }}.</h4>

                        <!-- >>> VueCmp - 'sdr-contact-box', 'Contact Box' -->
                        <sdr-contact-box></sdr-contact-box>
                        <!-- <<< VueCmp - 'sdr-contact-box', 'Contact Box' -->
                    </div>
                    <!-- <<< Right Side: Sidebar -->
                </div>
                <!-- <<< 'Bookinno Search Results' - Row -->
            </div>
        </div>
    </section>
</template>

<script>
    import BookingnoFlightDetails from './BookingnoFlightDetails.vue';

    import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs.vue';
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-bookingno-flight-details': BookingnoFlightDetails,
            'sdr-breadcrumbs': Breadcrumbs,
            'sdr-contact-box': ContactBox,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                headline_step1: {
                    en: 'Step 1: Here you can see your booking data.',
                    de: 'Schritt 1: Hier sehen Sie Ihre Buchungsdaten.'
                },
                proceed: {
                    en: 'Proceed to Book seats and services',
                    de: 'Weiter zu Sitzplätze und Services buchen'
                },
                resultsshown: {
                    en: 'Passenger(s) found',
                    de: 'Passagier(e) gefunden'
                },
                // ----------------------------------------
                tab_flightdetails: {
                    en: 'Your original booking',
                    de: 'Ihre ursprüngliche Buchung'
                },
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_FlagServicesShowBookingnoSearchResults', // Control Flag
                'get_ServicesBookingnoSearchResults', // Bookingno Search Results
                'get_ServicesBookingnoPassengersCount', // Passengers Count
                'get_ServicesBookingnoPassengersCountAll', //
                'get_ServicesBookingnoHasOutwardFlight', // has outward flight
                'get_ServicesBookingnoHasReturnFlight', // has return flight
                'get_areWeInServicesBookingNoMode',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytopushpassengers' ('All Calls done ...').
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> created');
            eventBus.$on('readytopushpassengers', this.onEmit_ReadyToPushPassengers);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> beforeDestroy');
            eventBus.$off('readytopushpassengers', this.onEmit_ReadyToPushPassengers);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_registrationBookingoptions', // Call: get 'bookingoptions'
                'actn_call_bookableServices', // Call: get 'bookable services'
                'actn_Flag_bookableServicesCallRetDidRun',
                'actn_setBookingUsersSearchData', // prepare/simulate pax data
                'actn_setBookingUpdateCart', // prepare/simulate update cart
                'actn_setBookingAirports',
                'actn_FlagServicesBookingnoLoginIsReadyForLogin',
                'actn_setBookingFlightIdSelectedOutward',
                'actn_setBookingFlightIdSelectedReturn',
            ]),


            /******************************************************************* 'ServiceCalls - Bookingno'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * call_NextCalls()
            *
            * Desc:
            * Note: 1.  Prepare/Simulate Passengers (See: FlightSearchTab => onSubmit).
            * NOte: 1b. Update Cart and more
            * Note: 2.  Do/Run the Call Chain ..
            * Note:
            * TODO: Is here more to set up in state for the 'Passenger' Step?
            * TODO: See: FlighSearchTab.vue >>> onSubmit
            *
            */
            call_nextCalls: function () {

                let me = this,
                    outwardFlight = this.get_ServicesBookingnoSearchResults[0].outwardFlight,
                    returnFlight = this.get_ServicesBookingnoSearchResults[0].returnFlight,
                    params = {},
                    flight = {};


                me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> call_nextCalls');
                // >>> 1. Prepare/Simulate -------------------------------------
                params = {
                    depArprtCode: outwardFlight !== undefined && outwardFlight !== null ? outwardFlight.departureAirportInfo.iataCode : null,
                    desArprtCode: outwardFlight !== undefined ? outwardFlight.destinationAirportInfo.iataCode: null,
                    noADT: this.get_ServicesBookingnoPassengersCount('ADT'),
                    noCHD: this.get_ServicesBookingnoPassengersCount('CHD'),
                    noINF: this.get_ServicesBookingnoPassengersCount('INF'),
                    ojArprtCode: '',
                    ojType: '',
                    depAfter: '',
                    rTrip: returnFlight !== undefined ? true : false,
                    limit: 5,
                };
                this.actn_setBookingUsersSearchData(params);                    // set/simulate/remember in state



                // >>> 1b. Prepare/Simulate ------------------------------------
                if (outwardFlight !== undefined && outwardFlight !== null) {                               // out
                    flight = {
                        flight: this.build_FlightObject('outward'),
                        modulo: this.modulo,
                        type: 'outward'
                    };
                    this.actn_setBookingUpdateCart(flight);

                    this.actn_setBookingAirports({
                        depArprtCode: outwardFlight.departureAirportInfo.iataCode,
                        depArprtName: outwardFlight.departureAirportInfo.location,
                        desArprtCode: outwardFlight.destinationAirportInfo.iataCode,
                        desArprtName: outwardFlight.destinationAirportInfo.location,
                    });

                    this.actn_setBookingFlightIdSelectedOutward(outwardFlight.id);
                }

                if (returnFlight !== undefined && returnFlight !== null) {                               // ret
                    flight = {
                        flight: this.build_FlightObject('return'),
                        modulo: this.modulo,
                        type: 'return'
                    };
                    this.actn_setBookingUpdateCart(flight);

                    // this.actn_setBookingAirports({
                    //     depArprtCode: returnFlight.departureAirportInfo.iataCode,
                    //     depArprtName: returnFlight.departureAirportInfo.location,
                    //     desArprtCode: returnFlight.destinationAirportInfo.iataCode,
                    //     desArprtName: returnFlight.destinationAirportInfo.location,
                    // });

                    this.actn_setBookingFlightIdSelectedReturn(returnFlight.id);
                }



                // >>> 2. Do/Run -----------------------------------------------
                this.call_registrationBookingoptions();                         // Call 1: 'get bookingoptions'
                this.call_bookableServices('outward');                          // Call 2: 'get bookableservices' - outward
                if (returnFlight !== undefined) {
                    this.call_bookableServices('return');                       // Call 2: 'get bookableservices' - return
                } else {
                    this.actn_Flag_bookableServicesCallRetDidRun(true);         // we fake it
                }

            }, // eo function call_nextCalls()


            /*******************************************************************
            * Call::'/registration/bookingoptions'
            *
            * Desc:
            * Note: New: Axios Call is here managed in VUEX.
            *
            */
            call_registrationBookingoptions: function () {

               var me = this,
                    outwardId = this.get_ServicesBookingnoSearchResults[0].outwardFlight,
                    returnId = this.get_ServicesBookingnoSearchResults[0].returnFlight,
                    flightIds = [],
                    params = {};


                me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> call_registrationBookingoptions');
                if (outwardId !== undefined) {
                    outwardId = this.get_ServicesBookingnoSearchResults[0].outwardFlight.id;
                }
                if (returnId !== undefined && returnId !== null) {
                    returnId = this.get_ServicesBookingnoSearchResults[0].returnFlight.id;
                }

                // >>> 1. Builds Object ----------------------------------------
                if (outwardId !== null && outwardId !== undefined && outwardId !== '') {
                  flightIds.push(String(outwardId));
                }
                if (returnId !== null && returnId !== undefined && returnId !== '') {
                  flightIds.push(String(returnId));
                }

                params = {
                    "bookingOptionsRQ" : {
                        "idFlights" : flightIds
                    }
                };


                this.actn_call_registrationBookingoptions(params);              // Call

            }, // eo function call_registrationBookingoptions()


            /*******************************************************************
            * Call::'/service/bookableservices/{idFlight}/{tktClass}'
            *
            * Desc:
            * Note: New: Axios Call is here managed in VUEX.
            *
            * @param {string} type ('outward','return')
            */
            call_bookableServices: function (type) {

                var me = this,
                    outwardId = this.get_ServicesBookingnoSearchResults[0].outwardFlight,
                    returnId = this.get_ServicesBookingnoSearchResults[0].returnFlight,
                    id = '';


                me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> call_bookableServices');
                // >>> 1. Builds Object -------------------
                if (outwardId !== undefined && type === 'outward') {
                    outwardId = this.get_ServicesBookingnoSearchResults[0].outwardFlight.id;
                    id = outwardId;

                    this.actn_call_bookableServices({ id: id, type: type });        // Call

                }
                if (returnId !== undefined && returnId !== null && type === 'return') {
                    returnId = this.get_ServicesBookingnoSearchResults[0].returnFlight.id;
                    id = returnId;

                    this.actn_call_bookableServices({ id: id, type: type });        // Call
                }

            }, // eo function call_bookableServices()




            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToPushPassengers()
            *
            * Desc: Handle 'Push Passengers' after all pre Calls are done.
            * Note:
            *
            */
            onEmit_ReadyToPushPassengers: function() {

                let me = this,
                    options = {};


                me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> onEmit_ReadyToPushPassengers');
                // >>> Scroll Options ------------------------------------------
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                // >>> Pushing/Scrolliing --------------------------------------
                this.actn_FlagServicesBookingnoLoginIsReadyForLogin(false);     // reset


                me.$router.push({ path: '/passengers/' + me.modulo });
                setTimeout(function() {
                    me.$scrollTo('#scrollPointTop', 200, options);
                }, 300);

            }, // eo function onEmit_ReadyToPushPassengers()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * build_FlightObject()
            *
            * Desc: Build/Rebuilds Fligths Object for Cart.
            * Note: Reason: Totally different FlightObject from Backend.
            * Note: In 'outwardFlight'=>OverView Call &&
            * Note: Flightobject in 'getFlights'.
            *
            * @param {string} type ('outward','return')
            */
            build_FlightObject: function(type) {

                let me = this,
                    outwardFlight = this.get_ServicesBookingnoSearchResults[0].outwardFlight,
                    returnFlight = this.get_ServicesBookingnoSearchResults[0].returnFlight,
                    flightObject = {};


                me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> build_FlightObject');
                // >>> ------------------------------------
                if (type === 'outward') {
                    if (outwardFlight !== undefined) {
                        flightObject = {
                            "depDT": outwardFlight.departureDateTimeLocal, // "2020-02-26T11:30:00+0100",
                            "desDT": outwardFlight.destinationDateTimeLocal, // "2020-02-26T15:55:00+0000",
                            "dur": outwardFlight.dur,

                        };
                    }
                }

                // >>> ------------------------------------
                if (type === 'return') {
                    if (returnFlight !== undefined && returnFlight !== null) {
                        flightObject = {
                            "depDT": returnFlight.departureDateTimeLocal, // "2020-02-26T11:30:00+0100",
                            "desDT": returnFlight.destinationDateTimeLocal, // "2020-02-26T15:55:00+0000",
                            "dur": returnFlight.dur,
                        };
                    }
                }


                return flightObject;

            }, // eo function build_FlightObject()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #flight-details .flights {
        padding-bottom: 0px;
    }
    #flight-details .flights .first-flight .logo:after {
        bottom: 23px;
    }

    .totalbutton {
        padding-right: 7px;
        height: 43px;
        font-size: 1.6667em; /* 1.4167em, 1.1667em; 1.6667em */
        line-height: 15px;
        text-align: right;
        height: 57px;
    }
    dl.term-description dt {
        color: #9e4d84;
    }
    .tab-container ul.tabs li.active > a,
    .tab-container ul.tabs li:hover > a {
        color: #9e4d84;
    }

    /* Price Table */
    .cruise-itinerary td {
        line-height: 2.5em;
        border: 1px solid #f5f5f5;
    }
    .booking-details .other-details {
        background-color: #f5f5f5;
    }
    .booking-details .other-details .total-price-value {
        font-size: 1.9167em;
    }
    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }
    .booking-details .other-details dt,
    .booking-details .other-details dd {
        padding-top: 0.4em;
        padding-bottom: 0.4em;
    }

    .icon-box.style9 > i {
        background: #9e4d84;
    }

    .hotel-faqs .topics li.active,
    #flight-fare-rules .topics li.active {
        background: #9e4d84;
    }

    /* Modal */
    .size-modal2-content {
        padding: 10px;
        font-style: 13px;
        background-color: rgb(255, 255, 255);
        padding-right: 50px;
    }
    .v--modal-overlay[data-modal='size-modal2'] {
        background: rgba(0, 0, 0, 0.5);
        z-index: 555555 !important;
    }
    .demo-modal-class {
        border-radius: 5px;
        background: #f7f7f7;
        box-shadow: 5px 5px 30px 0px rgba(46, 61, 73, 0.6);
    }

    .icon-check3 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check3:after {
        content: '';
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4a6e89;
    }

    /* a {
            color: rgb(119, 41, 85);
        } */

    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        h1 {
            font-size: 1.5em;
        }
        h2 {
            font-size: 1.4em;
        }
        button.btn-large,
        input[type='button'].button.btn-large,
        a.button.btn-large {
            font-size: 1em;
        }

        .booking-section {
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 20px;
            padding-left: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/services/pagecontent/BookingnoOverview.vue